import { Image, Link, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from "react";
import theme from '../../../../theme';
import { DashboardQuery } from '../../../../types/files';

const styles = StyleSheet.create({
    queryBlock: {
        width: '100%',
        height: 'auto',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        paddingVertical: 4,
    },
    answerBlock: {
        width: '100%',
        height: 'auto',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    title: {
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 'bold',
        color: '#666666',
    },
    url: {
        fontFamily: 'Inter',
        fontSize: 10,
        fontWeight: 700,
        color: theme.palette.primary.main,
        overflow: 'hidden',
        flexDirection: 'row',
    },
    icon: {
        width: 16,
        height: 16,
    },
});

const UrlRegex = /^(https?:\/\/)?(www\.)?([^\\/]+)(\/.*)?$/;
const LinkedInRegex = /linkedin\.com\/(company|showcase)\/([^\\/?]+)/;

const PDFLinkedInQuery: React.FC<{ query?: DashboardQuery }> = ({ query }) => {
    const answer = !!query?.answer ? JSON.parse(query.answer) : null;
    const parsed = !!answer ? answer?.answer : null;

    const getValidLink = () => {
        if (!!parsed) {
            const url = parsed;

            if (!!url && typeof url === 'string') {
                if (!url.includes('https') && !url.includes('http'))
                    return `https://${url}`;

                return url;
            }
        }

        return "";
    };

    const getDisplayLink = () => {
        const url = getValidLink().replace('https://', '').replace('http://', '');
        let display = '';

        if (LinkedInRegex.test(url)) {
            const matches = url.match(LinkedInRegex);
            display = !!matches ? `/${matches.pop()}` : display;
        } else if (UrlRegex.test(url)) {
            display = url.match(UrlRegex)?.[3] || display;
        }

        return display;
    };

    return (<>
        <View style={styles.queryBlock}>
            <View style={styles.answerBlock}>
                <Image style={styles.icon} src={'/images/linkedin-gray.png'} />
                <Link style={{ width: '100%', textDecoration: 'none' }} src={getValidLink()}>
                    <Text style={[styles.url, { paddingLeft: 8 }]}>
                        {getDisplayLink()}
                    </Text>
                </Link>
            </View>
        </View>
    </>);
}

export default PDFLinkedInQuery;
